export default () => {
  return {
    orderTypes: [
      { value: '', text: 'All' },
      { value: 'draft', text: 'Draft Order' },
      { value: 'shipbob', text: 'Shipbob Order' },
    ],

    draftStatuses: [
      { value: '', text: 'All' },
      { value: 'draft', text: 'Draft' },
      { value: 'finalized', text: 'Finalized' },
      { value: 'cancelled', text: 'Cancelled' }
    ],

    orderStatuses: [
      { value: '', text: 'All' },
      { value: 'ImportReview', text: 'Import Review' },
      { value: 'Processing', text: 'Processing' }, // Custom status, modified from SB
      { value: 'InTransit', text: 'Shipped' }, // Custom status, not from SB
      { value: 'Completed', text: 'Delivered' }, // Custom status, not from SB
      { value: 'Cancelled', text: 'Cancelled' },
      { value: 'Exception', text: 'Exception' },
    ],

    shipmentType: [
      { value: '', text: 'All' },
      { value: 'DTC', text: 'Direct to Consumer (DTC)' },
      { value: 'B2B', text: 'Business to Business (B2B)' },
    ],

    carrierType: [
      { value: '', text: 'All' },
      { value: 'parcel', text: 'Parcel' },
      { value: 'freight', text: 'Freight' },
    ]
  }
}